import GetSharingInfoResponse from 'owa-service/lib/contract/GetSharingInfoResponse';
import { action } from 'satcheljs';

export const onSharePointLinkDetected = action(
    'ON_SHAREPOINT_LINK_DETECTED',
    (
        linkId: string,
        linkUrl: string,
        sharingLinkIds: string[],
        response: GetSharingInfoResponse,
        shouldAddComposeLinkViewState: boolean,
        isPreviouslyBeautified: boolean
    ) => ({
        linkId: linkId,
        linkUrl: linkUrl,
        sharingLinkIds: sharingLinkIds,
        response: response,
        shouldAddComposeLinkViewState: shouldAddComposeLinkViewState,
        isPreviouslyBeautified: isPreviouslyBeautified,
    })
);
